import ModalMacros from "./ModalMacros"

export default ModalMacros
